/** Local App Store screenshot assets (from Apple App Store listing). */
export const APP_ICON = "/images/app-icon.png";
export const OG_COVER = "/images/og-cover.png";

export const APP_SCREENSHOTS = [
    {
        src: "/images/screenshots/screen-1.webp",
        alt: "Quran Chat Buddy AI Islamic chat screenshot",
        caption: "Ask Quran questions with AI guidance",
    },
    {
        src: "/images/screenshots/screen-2.webp",
        alt: "Quran Chat Buddy prayer times screenshot",
        caption: "Accurate Salah prayer times & reminders",
    },
    {
        src: "/images/screenshots/screen-3.webp",
        alt: "Quran Chat Buddy daily ayat screenshot",
        caption: "Daily ayat reflections for Muslims",
    },
    {
        src: "/images/screenshots/screen-4.webp",
        alt: "Quran Chat Buddy Quran learning screenshot",
        caption: "Learn Quran with tafsir & translation",
    },
    {
        src: "/images/screenshots/screen-5.webp",
        alt: "Quran Chat Buddy deen growth screenshot",
        caption: "Grow your deen every day",
    },
    {
        src: "/images/screenshots/screen-6.webp",
        alt: "Quran Chat Buddy Islamic companion screenshot",
        caption: "A peaceful Islamic companion app",
    },
    {
        src: "/images/screenshots/screen-7.webp",
        alt: "Quran Chat Buddy Muslim app screenshot",
        caption: "Quran, prayer & spiritual growth",
    },
];

export const HERO_SCREENSHOT = APP_SCREENSHOTS[0];
